import React, {useState, useEffect} from 'react';
import {Grid, Paper, Container, Typography,
    TextField,
    Button, Divider} from '@material-ui/core';
import Alert from '@mui/material/Alert';
import CircularProgress from "@material-ui/core/CircularProgress";
import {makeStyles} from "@material-ui/core/styles";
const useStyles = makeStyles({
    messagingGroupsAll: {
        textStyle: "Core / LG / page-title",
        fontFamily: "Chronicle Text G1 ",
        fontStyle: "semiBold",
        fontSize: "48px ",
        align: "left",
        verticalAlign: "top",
        letterSpacing: "0.5px",
        paddingTop: "61px"
    },
    divider: {
        fill: "solid",
        borderBottom: "6px solid #B40F87",
        marginBottom: "16px !important",
        marginTop: "10px !important",
        content: '""',
        position: "absolute",
        left: 0,
        bottom: 0,
        width: 40,
    },
    content: {
        color: "#6D6D6E ",
        fontSize: "32px ",
        fontStyle: "semiBold ",
    },
    alertContent: {
        marginTop: '46px !important',
        backgroundColor: "white !important",
        borderLeft: '5px solid #DB6200',
        boxShadow: '',
        fontSize: "20px !important"
    },
    paper: {
        boxShadow: "0px 0px 0px 0px !important",
        paddingTop: "46px !important"
    },
    basicInfo: {
        fontFamily: "Whitney !important",
        fontWeight: "bold !important",
        fontSize: "16px !important",
        align: "left",
        verticalAlign: "top"
    },
    textField: {
        paddingTop: "6px !important",
    },
    lastName: {
        marginTop: "24px !important",
    },
    dob: {
        marginTop: "42px !important",
    },
    button: {
        marginTop: "42px !important",
        marginBottom: "48px !important",
    },
    textInfo: {
        fontFamily: "Whitney !important",
        fontSize: "18px !important",
        align: "left",
        verticalAlign: "top",
        marginTop: "20px",
    },
    textButton: {
        paddingLeft: "0px !important",
        fontFamily: "Whitney !important",
        fontWeight: "bold !important",
        letterSpacing: "1.25px",
        fontSize: "1rem !important",
        // marginTop: "24px !important",
        // marginBottom: "48px !important",
    },
})
const BasicInformation = ({
                               handleSubmit = () => {},
                               errorFindingPatient = null,
                               errorAddingCreditCard = null,
                                existingCCStatusRes=[],
                               isWaiting = false
                           }) => {
    const classes = useStyles();
    const [firstNameError, setFirstNameError] = useState(null);
    const [firstName, setFirstName] = useState("");
    const [lastNameError, setLastNameError] = useState(null);
    const [lastName, setLastName] = useState("");
    const [dateOfBirthError, setDateOfBirthError] = useState(null);
    const [dateOfBirth, setDateOfBirth] = useState("");
    const [zipCodeError, setZipCodeError] = useState(null);
    const [zipCode, setZipCode] = useState("");

    const resetState = () => {
        setFirstNameError(null);
        setFirstName("");
        setLastNameError(null);
        setLastName("");
        setDateOfBirthError(null);
        setDateOfBirth("");
        setZipCodeError(null);
        setZipCode("");
    }

    useEffect(() => {
        resetState();
    }, []);
    const handleFirstNameOnChange = (e) =>{
        if (!!firstNameError) setFirstNameError(null);
        setFirstName(e.target.value);
    }

    const handleLastNameOnChange = (e) =>{
        if (!!lastNameError) setLastNameError(null);
        setLastName(e.target.value);
    }

    const handleBirthdayChange = (e) =>{
        if(!!dateOfBirthError) setDateOfBirthError(null)
        setDateOfBirth(e.target.value);
    }

    const handleZipCodeChange = (e) =>{
        if(!!zipCodeError) setZipCodeError(null)
        setZipCode(e.target.value);
    }

    const validate = () => {
        let valid = true;
        const validZipRegex =  /(^\d{5}$)|(^\d{5}-\d{4}$)/;
       // const nameRegex = /[A-Za-z]/;
       const nameRegex = /^[a-zA-Z'\s\-]+(\s*[a-zA-Z])*$/;
        if (!firstName || firstName.trim() === "" || !nameRegex.test(firstName.trim())) {
            valid = false;
            setFirstNameError("Please enter a valid First name");
        }
        if (!lastName || lastName.trim() === "" || !nameRegex.test(lastName.trim())) {
            valid = false;
            setLastNameError("Please enter a valid Last name");
        }//
        if (!dateOfBirth || dateOfBirth.trim() === "") {
            valid = false;
            setDateOfBirthError("Please enter a valid DOB description");
        }
        if (!zipCode || zipCode.trim() === "" || !validZipRegex.test(zipCode.trim())) {
            valid = false;
            setZipCodeError("Please enter a valid zip code");
        }
        // debugger;
        if (valid) return valid;
    }
    const submit = () => {
        handleSubmit({
            "firstName" :firstName,
            "lastName": lastName,
            "dateOfBirth": dateOfBirth,
            "zipCode": zipCode,
        }, resetState);
    }

    const sendNow = () => {
        if (validate()) {
                submit();
        }
    }

    /* Required fields validation */
    const [canSubmitForm, setCanSubmitForm] = useState(false);
    const validateRequiredFields = () => {
        console.log("validating");
        const valid = !!(
            // API Name
            (firstName && firstName.trim() !== "") &&
            // API Description
            (lastName && lastName.trim() !== "") &&
            // Application Name
            (dateOfBirth && dateOfBirth.trim() !== "") &&
            // Requestor Email
            (zipCode && zipCode.trim() !== "")
        )
        setCanSubmitForm(valid);
    }
    /* Run validation on checkboxes, radios */
    useEffect(validateRequiredFields);

        return (
            <>
        <Container>
        <Typography style={{fontSize: "48px",fontWeight: 400, padding: "1em 0 1rem", letterSpacing: "0.5px",
            lineHeight: "55px",
            fontFamily: '"Chronicle Text G1", "Frank Ruhl Libre", serif',
            position: "relative",
            marginBottom: "1em",
            }}>Ascension Rx Payment Details <Divider style={{borderBottom: "6px solid #B40F87", width: 40}}/></Typography>

            <Typography style={{color: "#6D6D6E ", fontSize: "24px ", fontStyle: "semiBold ", margin: "35px, 0px" , fontFamily: "Whitney"}}>We are ready to fill your prescription and need to collect payment information.
               <br/> Please enter patient information below.</Typography>
            {
                errorFindingPatient && (
                    <Alert severity="warning" className={classes.alertContent}>
                        <Typography >We were unable to locate an account with the information you provided.</Typography>
                        <Typography variant="caption" style={{fontSize: "14px"}}>Ensure you entered your information correctly.</Typography>
                    </Alert>
                )
            }
            {
                errorFindingPatient && (
                    <Grid item container direction="column">
                        <Typography className={classes.textInfo}>If you have not completed the account set up form, please do this step first.</Typography>
                    </Grid>
                )}
            {errorFindingPatient && (
                <Grid item container direction="row" justify="flex-start" spacing={2}>
                    <Grid item >
                        <Button className={classes.textButton}
                            // disabled={selectedGroups.length === 0 || messageText === ""}
                            // variant="contained"
                                size="large"
                                color="primary"
                                onClick={() => {
                                    window.open("https://healthcare.ascension.org/ascensionrxtransfer")
                                }}
                        >
                            SET UP MY ASCENSION RX ACCOUNT
                        </Button>
                    </Grid>
                </Grid>
            )}
            {
                errorAddingCreditCard && (
                    <Alert severity="warning" className={classes.alertContent}>
                        {existingCCStatusRes}
                    </Alert>
                )
            }

            <Paper className={classes.paper}>
                <Grid item container direction="column" spacing={2}>
                    <Grid item container direction="column">
                        <Typography className={classes.basicInfo}>First Name</Typography>
                    </Grid>
                    <Grid item container direction="row" spacing={4}>
                        <Grid item xs={8} container direction="column" spacing={2} className={classes.textField}>
                            <Grid item>
                                <TextField
                                    error={!!firstNameError}
                                    required
                                    style={{
                                        backgroundColor: "white",
                                        width: "299px",
                                        height: "48px"
                                    }}
                                    variant="outlined"
                                    type="text"
                                    value={firstName}
                                    helperText={!!firstNameError && firstNameError}
                                    onChange={handleFirstNameOnChange}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item container direction="column" className={classes.lastName}>
                        <Typography className={classes.basicInfo}>Last Name</Typography>
                    </Grid>
                    <Grid item container direction="row" spacing={4}>
                        <Grid item xs={8} container direction="column" spacing={2} className={classes.textField}>
                            <Grid item>
                                <TextField
                                    required
                                    error={!!lastNameError}
                                    style={{
                                        backgroundColor: "white",
                                        width: "299px",
                                        height: "48px",
                                    }}
                                    variant="outlined"
                                    type="text"
                                    value={lastName}
                                    helperText={!!lastNameError && lastNameError}
                                    onChange={handleLastNameOnChange}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item container direction="column" className={classes.dob}>
                    <Typography className={classes.basicInfo}>Date of Birth</Typography>
                </Grid>
                <Grid item container direction="row" spacing={4} className={classes.textField}>
                    <Grid item xs={8} container direction="column" spacing={2} >
                        <Grid item>
                            <TextField
                                required
                                style={{
                                    backgroundColor: "white",
                                    width: "220px",
                                    height: "48px",
                                }}
                                variant="outlined"
                                type="date"
                                value={dateOfBirth}
                                error={!!dateOfBirthError}
                                onChange={handleBirthdayChange}
                                helperText={!!dateOfBirthError && dateOfBirthError}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item container direction="column" className={classes.dob}>
                    <Typography className={classes.basicInfo}>Zip Code</Typography>
                </Grid>
                <Grid item container direction="row" spacing={4} className={classes.textField}>
                    <Grid item xs={8} container direction="column" spacing={2} >
                        <Grid item>
                            <TextField
                                required
                                error={!!zipCodeError}
                                style={{
                                    backgroundColor: "white !important",
                                    width: "299px",
                                    height: "48px",
                                }}
                                variant="outlined"
                                value={zipCode}
                                helperText={!!zipCodeError && zipCodeError}
                                onChange={handleZipCodeChange}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item container direction="row" justify="flex-start" spacing={2}>
                    <Grid item className={classes.button}>
                        <Button
                            variant="contained"
                            size="large"
                            color="primary"
                            className={classes.submitButton}
                            onClick={sendNow}
                            disabled={!canSubmitForm || isWaiting} 
                        >
                            {isWaiting ? <CircularProgress /> : "Continue"}
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </Container>
                </>
    )
}

export default BasicInformation;

